module.exports = __webpack_public_path__ + "static/Opsmanual-0a962410e14014cebc4ca26b62cd122a.pdf";